'use client';

import styles from './VideoHighlightsSectionCard.module.scss';
import React from 'react';
import { RichText } from '@sitecore-jss/sitecore-jss-react';
import { useMediaQuery } from 'usehooks-ts';
export default function VideoHighlightsSectionCard({ card }) {
  // const [isPlaying, setIsPlaying] = useState<boolean>(false);
  //
  // const toggleVideoPlay = () => {
  //   setIsPlaying((prev) => !prev);
  // };
  const isMobile = useMediaQuery('(max-width: 480px)');
  return (
    <div className={styles.card}>
      <div>
        <div className={styles.card_imageContainer} data-aos="fade-up" data-aos-offset={200}>
          {isMobile ? (
            // <Image src={card?.fields?.mobileImage?.value?.src} alt={'img'} />
            <img
              src={card?.fields?.mobileImage?.value.src}
              alt={card?.fields?.mobileImage?.value.alt}
              width={card?.fields?.mobileImage?.value.width}
              height={card?.fields?.mobileImage?.value.height}
            />
          ) : (
            // <Image src={card?.fields?.image?.value?.src} alt={'img'} />
            <img
              src={card?.fields?.image?.value?.src}
              alt={card?.fields?.image.value.alt}
              width={card?.fields?.image.value.width}
              height={card?.fields?.image.value.height}
            />
          )}
        </div>
        <div className={styles.card_content} data-aos="fade-up" data-aos-offset={200}>
          <div>
            <div className={styles.card_content_title}>
              <RichText field={card.fields?.title} />
            </div>
            <div className={styles.card_content_text}>
              <RichText field={card.fields?.desc} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
